import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function ContractSalaryCalc({ setOverlayView }) {
    const { t } = useTranslation();
    const [sum, setSum] = useState('');
    const [salaryType, setSalaryType] = useState('gross');
    const [percent, setPercent] = useState('');
    const [result, setResult] = useState('');

    const handleCalculate = () => {
        const sumNum = parseFloat(sum);
        const percentNum = parseFloat(percent);
        if (Number.isNaN(sumNum) || Number.isNaN(percentNum)) {
            setResult('');
            return;
        }
        const multiplier = 1 + percentNum / 100;
        const value = salaryType === 'gross'
            ? sumNum / multiplier   // Брутно: извличаме основата от брутната сума
            : sumNum * multiplier;  // Основно: добавяме процента към основата
        setResult(value.toFixed(2));
    };

    const handleClear = () => {
        setSum('');
        setSalaryType('gross');
        setPercent('');
        setResult('');
    };

    return (
        <>
            <div className="flex-column position-center">
                <h3 className="form-subtitle">{t('persons.personContract.calculateSalaryTitle', 'Калкулатор заплата')}</h3>
                <div className="grid-label-value">
                    <span>Сума</span>
                    <input
                        type="number"
                        className="small-input"
                        value={sum}
                        onChange={(e) => setSum(e.target.value)}
                    />
                    <span>Вид на възнаграждението :</span>
                    <div className="flex-row">
                        <label className="label-inline">
                            <input
                                type="radio"
                                name="salaryType"
                                value="gross"
                                checked={salaryType === 'gross'}
                                onChange={() => setSalaryType('gross')}
                            />
                            <span>Брутно</span>
                        </label>
                        <label className="label-inline">
                            <input
                                type="radio"
                                name="salaryType"
                                value="net"
                                checked={salaryType === 'net'}
                                onChange={() => setSalaryType('net')}
                            />
                            <span>Основно</span>
                        </label>
                    </div>
                    <span>Процент доплащане за стаж:</span>
                    <input
                        type="number"
                        className="small-input"
                        value={percent}
                        onChange={(e) => setPercent(e.target.value)}
                    />
                    <span>Резултат:</span>
                    <input
                        type="number"
                        className="small-input"
                        readOnly
                        value={result}
                        tabIndex={-1}
                        aria-readonly
                    />
                </div>
            </div>
            <div className="form-controls">
                <button type="button" className="form-btn btn-blue" onClick={handleCalculate}>
                    Изчисли
                </button>
                <button type="button" className="form-btn btn-green" onClick={handleClear}>
                    Изчисти
                </button>
                <button
                    type="button"
                    className="form-btn btn-red"
                    onClick={() => setOverlayView(null)}
                    title={t('common.exit') || 'Exit'}
                >
                    {t('common.exit') || 'Exit'}
                </button>
            </div>
        </>
    );
}
